<template>
<div class="chapter">
<div class="inner_page">
<p class="ded">For my wife Magi Prins, and my brothers and sisters; Andy and Fran, Jackie Cain and Roy Kral, Dick Druz, Lou Alfano, Jerry Cole, John Wilcock, Don and Marianne DeFina, Ken Pell, Bob and Gail Gillman, wherever they may be …</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a99222e2